module.exports = __webpack_public_path__ + "static/media/032-The Porch.9ce88afb.jpg";